import { render } from "./HeroiconsOutlineCash.vue?vue&type=template&id=5a33dd10"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCash.vue"]])

export default __exports__